// config.ts

//API URL
//**** prod ****
export const API_URL = 'https://extendedwarranty.mmtraining.co.za/api';
//**** dev ****
//export const API_URL = 'http://localhost:3001';